import { useMemo, useState } from 'react';
import { SortDirection } from '../models/DataTable';

const compareValues = (left: unknown, right: unknown): number => {
    if (left == null && right == null) return 0;
    if (left == null) return 1;
    if (right == null) return -1;

    if (typeof left === 'number' && typeof right === 'number') return left - right;
    return String(left).localeCompare(String(right), undefined, { numeric: true, sensitivity: 'base' });
};

const useSortableData = <T,>(data: T[], getValue: (item: T, key: string) => unknown, defaultSortBy = '') => {
    const [sortBy, setSortBy] = useState(defaultSortBy);
    const [sortDirection, setSortDirection] = useState<SortDirection>('asc');

    const sortedData = useMemo(() => {
        if (!sortBy) return data;
        return [...data].sort((left, right) => {
            const result = compareValues(getValue(left, sortBy), getValue(right, sortBy));
            return sortDirection === 'asc' ? result : -result;
        });
    }, [data, getValue, sortBy, sortDirection]);

    const onSort = (key: string) => {
        setSortDirection(current => sortBy === key && current === 'asc' ? 'desc' : 'asc');
        setSortBy(key);
    };

    return { data: sortedData, sortBy, sortDirection, onSort };
};

export default useSortableData;
